
















































import { defineComponent } from "@vue/composition-api";
import { Button, Cell, CellGroup, Dialog, Field, Popover, Popup, Tab, Tabs } from "vant";
import MyShareItem from "./my-share-item.vue";
import Share from "./share.vue";
import moment from "moment";

moment.locale("zh-cn");
import axios from "@/helpers/axios";

export default defineComponent({
  name: "share-btn",
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    MyShareItem,
    Share
  },
  props: {
    shareId: {
      type: Number,
      default: 0
    },
    isSettle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showShareList: false,
      shareToList: [] as {
        shareId: number;
        endTime: number;
        isSiteLimited: boolean;
        siteList: { id: number; siteName: string }[];
        toUserId: number;
        toUserInfo: string;
      }[],
      shareFromList: [] as {
        shareId: number;
        endTime: number;
        isSiteLimited: boolean;
        siteList: { id: number; siteName: string }[];
        fromUserId: number;
        fromUserInfo: string;
      }[],
      showShareManage: false,
      showCheckOtherBtn: false,
      showCheckOtherDialog: false,
      otherPhone: ""
    };
  },
  created() {
    if (this.shareId == 0) {
      this.loadShareList();
    }
  },
  methods: {
    // user share
    async loadShareList() {
      const data = await axios
        .post("/api/manage/account/getShareList", { type: 1 })
        .then(res => res.data.data)
        .catch(() => {
          return { shareToList: [], shareFromList: [] };
        });
      this.shareToList = data.shareToList;
      this.shareFromList = data.shareFromList;
      this.showCheckOtherBtn = data.showCheckOtherBtn;
    },
    formatTime(time: number | Date) {
      return moment(time).format("lll");
    },
    useShare(shareId: number) {
      // this.showShareList = false;
      // this.shareId = shareId;
      if (this.isSettle) {
        this.$toMiniAppWeb("/web/manager/v/settle/account-stat?shareId=" + shareId);
      } else {
        this.$toMiniAppWeb("/web/manager/v/account/stat?shareId=" + shareId);
      }
    },
    async revokeShare(shareId: number) {
      const confirm = await Dialog.confirm({
        message: "您确定要撤销吗?"
      }).then(() => true);
      if (!confirm) return;
      const res = await axios
        .post("/api/manage/account/revokeShare", { shareId: shareId })
        .then(() => true)
        .catch(() => false);
      if (res) {
        await this.loadShareList();
      }
    }
  }
});
